module.exports = __webpack_public_path__ + "ce65b899b3f5f1741cb56771ca808408.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/cover/cover-mobile.mp4
// module id = 260
// module chunks = 1